import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const customerModule = {
  namespaced: true,
  state: {
    customers: null,
    customer: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default customerModule;
